import '../../../../css/SingleRingBuilder/saveWishlistModal.css';
import React, { useState, useContext } from "react";
import axios from "axios";
import { GlobalContext } from '../../../utils/GlobalContext';
import { CONSTANT } from '../../../utils/constants';

export const SaveWishlist = ({
    toggleSaveWishlistModal,
    styleNumber,
    headKarat,
    headColor,
    shankKarat,
    shankColor,
    centerStoneWeight,
    centerStoneShape,
    headDiamondQuality,
    shankDiamondQuality,
    fingerSize,
    modelComponents,
    canvasImage,
}) => {
    const headMetal  = [headKarat, headColor].filter(Boolean).join(' ');
    const shankMetal = [shankKarat, shankColor].filter(Boolean).join(' ');

    const { client_code } = useContext(GlobalContext);

    const [formData, setFormData] = useState({
        wishlist_name: '',
        wishlist_email: '',
        wishlist_phone: '',
    });
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');
        setSubmitting(true);
        try {
            const base_url = `${CONSTANT.BASE_URL}api/Builder/save-wishlist`;
            const response = await axios.post(base_url, {
                wishlist_name:        formData.wishlist_name,
                wishlist_email:       formData.wishlist_email,
                wishlist_phone:       formData.wishlist_phone,
                style_number:         styleNumber,
                metal_type:           headMetal,
                head_metal:           headMetal,
                shank_metal:          shankMetal,
                center_stone_weight:  centerStoneWeight,
                center_stone_shape:   centerStoneShape,
                head_diamond_quality:  headDiamondQuality,
                shank_diamond_quality: shankDiamondQuality,
                Finger_size:          fingerSize,
                modelComponents:      modelComponents,
                page_type:            'SingleRingBuilder',
                type_wishlist:        'General',
                account_number:       client_code,
                canvasImage:          canvasImage ?? null,
            });
            if (response.data.type === 'success') {
                setSuccessMessage(response.data.messages);
                setTimeout(() => toggleSaveWishlistModal(), 3000);
            } else {
                setErrorMessage(response.data.messages || 'Unable to save. Please try again.');
            }
        } catch {
            setErrorMessage('Error submitting the form. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modalSaveWishlist">
            <div className="modal-content">
                <div className="wishlist-header">
                    <h4>
                        <i className="fa fa-heart" aria-hidden="true"></i> SAVE TO WISHLIST
                    </h4>
                    <button className="btn-close-wishlist" onClick={toggleSaveWishlistModal} aria-label="Close">&times;</button>
                </div>

                <div className="wishlist-body">
                    <div className="wishlist-section-label">INDIVIDUAL</div>
                    <div className="wishlist-option-card selected">
                        <div className="card-left">
                            <div className="card-icon">
                                <i className="fa fa-user" aria-hidden="true"></i>
                            </div>
                            <div>
                                <div className="card-title">General Wishlist</div>
                                <div className="card-subtitle">Save as a personal item</div>
                            </div>
                        </div>
                        <div className="check-icon">
                            <i className="fa fa-check" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>

                <div className="wishlist-product-preview">
                    {canvasImage && (
                        <div className="wishlist-canvas-thumb">
                            <img src={canvasImage} alt="Ring preview" />
                        </div>
                    )}
                    <div className="wishlist-product-info">
                        {styleNumber && (
                            <div className="product-info-row">
                                <span className="info-label">Style #</span>
                                <span className="info-value">{styleNumber}</span>
                            </div>
                        )}
                        {headMetal && (
                            <div className="product-info-row">
                                <span className="info-label">Head Metal</span>
                                <span className="info-value">{headMetal}</span>
                            </div>
                        )}
                        {shankMetal && (
                            <div className="product-info-row">
                                <span className="info-label">Shank Metal</span>
                                <span className="info-value">{shankMetal}</span>
                            </div>
                        )}
                        {headDiamondQuality && (
                            <div className="product-info-row">
                                <span className="info-label">Head Diamond Quality</span>
                                <span className="info-value">{headDiamondQuality}</span>
                            </div>
                        )}
                        {shankDiamondQuality && (
                            <div className="product-info-row">
                                <span className="info-label">Shank Diamond Quality</span>
                                <span className="info-value">{shankDiamondQuality}</span>
                            </div>
                        )}
                        {(centerStoneWeight || centerStoneShape) && (
                            <div className="product-info-row">
                                <span className="info-label">Center Stone</span>
                                <span className="info-value">
                                    {[centerStoneShape, centerStoneWeight ? `${centerStoneWeight} ct` : null].filter(Boolean).join(' · ')}
                                </span>
                            </div>
                        )}
                        {fingerSize && (
                            <div className="product-info-row">
                                <span className="info-label">Finger Size</span>
                                <span className="info-value">{fingerSize}</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="wishlist-form-section">
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <label className="form-label">NAME</label>
                        <input
                            className="form-control"
                            type="text"
                            name="wishlist_name"
                            value={formData.wishlist_name}
                            onChange={handleChange}
                            required
                        />

                        <label className="form-label">EMAIL</label>
                        <input
                            className="form-control"
                            type="email"
                            name="wishlist_email"
                            value={formData.wishlist_email}
                            onChange={handleChange}
                            required
                        />

                        <label className="form-label">PHONE</label>
                        <input
                            className="form-control"
                            type="tel"
                            name="wishlist_phone"
                            placeholder="999-999-9999"
                            value={formData.wishlist_phone}
                            onChange={handleChange}
                        />
                        <span className="phone-hint">999-999-9999</span>

                        <div className="wishlist-footer">
                            <button type="button" className="btn-new-wishlist">
                                <i className="fa fa-plus-circle" aria-hidden="true"></i> New Wishlist
                            </button>
                            <button type="submit" className="btn-save-wishlist" disabled={submitting}>
                                <i className="fa fa-check" aria-hidden="true"></i> {submitting ? 'Saving...' : 'Save Wishlist'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
